'use strict';

var FastClick = require('fastclick');
var LayoutView = require('base/Colido.LayoutView');
var ModalListView = require('modules/global/views/partials/modal-list');
var template = require('../../templates/layout/main.hbs');

var AppShareLayout = LayoutView.extend({
    template: template,

    el: '#app',

    regions: {
        mainRegion: '#main',
        contentRegion: '#content',
        modalsRegion: '#modals',
    },

    events: {
        'click a': 'clickHandler',
    },

    initialize: function() {
        this.render().triggerMethod('attach');

        FastClick.attach(document.body);

        // Attach modal list view
        this.modalsRegion.show(new ModalListView({
            collection: App.radio().request('modals:collection'),
        }));

        return LayoutView.prototype.initialize.apply(this, arguments);
    },

    onRender: function() {
        $('html').addClass('share-app');
    },

    isInternalLink: function(event) {
        var target = $(event.currentTarget);
        var href = target.attr('href');

        return href && !href.match(/^([a-z-]+:|\/\/)/) && target.attr('rel') !== 'external';
    },

    clickHandler: function(event) {
        if (this.isInternalLink(event) && !event.isDefaultPrevented()) {
            var href = $(event.currentTarget).attr('href');
            App.router.navigate(href, {trigger: true});
            event.preventDefault();
        }
    },

    addModal: function(content, options) {
        return App.radio().request('modals:collection').add({content: content, options: options}).get('view');
    },
});

module.exports = AppShareLayout;